module.exports = __webpack_public_path__ + "img/xinpzzxclick.d714f292.svg";